import { logger } from '../../../../utils/logger';
import { attachJsSessionLifecycleListeners } from './peer-connection-debug.util';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type WebRtcService = any;

export function installAgentLegCallInterceptor(webRtcService: WebRtcService): void {
  const originalMakeAgentLegCall = webRtcService.makeAgentLegCall?.bind(webRtcService);
  if (!originalMakeAgentLegCall) {
    return;
  }

  webRtcService.makeAgentLegCall = function (...args: unknown[]) {
    logger.debug('[CXone DEBUG] makeAgentLegCall() called');
    logger.debug('[CXone DEBUG]   agentLegId:', webRtcService.agentLegId);
    logger.debug('[CXone DEBUG]   lastAgentLegIdCall:', webRtcService.lastAgentLegIdCall);
    logger.debug('[CXone DEBUG]   audioCodeIsConnected:', webRtcService.audioCodeIsConnected);
    logger.debug('[CXone DEBUG]   audioCodeCall (existing):', webRtcService.audioCodeCall);
    logger.debug('[CXone DEBUG]   options:', JSON.stringify(webRtcService.options));

    const result = originalMakeAgentLegCall(...args);

    setTimeout(() => {
      const call = webRtcService.audioCodeCall;
      logger.debug('[CXone DEBUG] After makeAgentLegCall:');
      logger.debug('[CXone DEBUG]   audioCodeCall exists:', !!call);
      if (call) {
        logger.debug('[CXone DEBUG]   call.data:', JSON.stringify(call.data || {}));
        logger.debug('[CXone DEBUG]   call.isEstablished():', call.isEstablished?.() ?? 'N/A');
        logger.debug('[CXone DEBUG]   call.isTerminated():', call.isTerminated?.() ?? 'N/A');

        const jsSession = call.js_session;
        if (jsSession) {
          logger.debug('[CXone DEBUG]   JsSIP session status:', jsSession.status);
          logger.debug('[CXone DEBUG]   JsSIP session direction:', jsSession.direction);
          attachJsSessionLifecycleListeners(jsSession);
          logger.debug('[CXone DEBUG] Added JsSIP session event listeners');
        }
      }
    }, 100);

    return result;
  };
}
